const inFlightMap = new Map();
const cacheMap = new Map();

export async function singleFlight(key, fn) {
  const k = String(key || '');
  if (!k) return await fn();
  if (inFlightMap.has(k)) return await inFlightMap.get(k);

  const p = Promise.resolve()
    .then(fn)
    .finally(() => {
      if (inFlightMap.get(k) === p) {
        inFlightMap.delete(k);
      }
    });

  inFlightMap.set(k, p);
  return await p;
}

export async function singleFlightCached(key, ttlMs, fn) {
  const k = String(key || '');
  const ttl = Math.max(0, Number(ttlMs || 0));
  if (!k || ttl <= 0) return await singleFlight(k, fn);

  const now = Date.now();
  const cached = cacheMap.get(k);
  if (cached && cached.expiresAt > now) {
    return cached.value;
  }

  const value = await singleFlight(k, fn);
  cacheMap.set(k, {
    value,
    expiresAt: now + ttl,
  });
  return value;
}

